import * as React from 'react';

import { DataQualityDetailProps, DataQualityType, localizeDataQualityTypeName } from '@tableau/data-catalog-client-components';
import { DataQualityAssetType } from '@tableau/data-catalog-client-components/lib/src/dataQuality/DataQualityDetail';
import { SiteUrls } from '@tableau/shared-urls';
import { ListItem } from '@tableau/widgets';
import { L10n } from '../../ts/L10n/L10n';
import { IDataQualityIndicatorInfo } from '../../ts/models/IDataQualityIndicatorInfo';

export function dataQualityTypeListItem(type: DataQualityType): ListItem {
  return {
    content: <span>{localizeDataQualityTypeName(type)}</span>,
    value: dataQualityTypeToString(type)
  };
}

export const dataQualityTypes: DataQualityType[] = [
  DataQualityType.WARNING,
  DataQualityType.DEPRECATED,
  DataQualityType.STALE,
  DataQualityType.MAINTENANCE
];

export function dataQualityTypeToString(type: DataQualityType): string {
  return DataQualityType[type];
}

export function stringToDataQualityType(type: string): DataQualityType {
  switch (type) {
    case DataQualityType[DataQualityType.WARNING]: return DataQualityType.WARNING;
    case DataQualityType[DataQualityType.DEPRECATED]: return DataQualityType.DEPRECATED;
    case DataQualityType[DataQualityType.STALE]: return DataQualityType.STALE;
    case DataQualityType[DataQualityType.MAINTENANCE]: return DataQualityType.MAINTENANCE;
  }
  return DataQualityType.WARNING;
}

export function dataQualityIndicatorInfoToProps(
  props: { assetUrl: string, assetName: string, assetType: DataQualityAssetType, onContentItem: boolean},
  urls: SiteUrls, info?: IDataQualityIndicatorInfo): DataQualityDetailProps | null {

  if (!info) {
    return null;
  }

  if (!info.isActive) {
    return null;
  }

  const owner = info.owner;

  return {
    assetType: props.assetType,
    authorName: owner ? owner.displayName : '',
    authorUrl: owner ? urls.userUrl(owner.username, owner.domainName) : '',
    localizedDate: L10n.localizedDateTime(info.updatedAt),
    type: stringToDataQualityType(info.type),
    message: info.message,
    newTab: false,
    ...props
  };
}
